import { useEffect, useState } from 'react'
import usePost from './usePost'

const useUploadFile = (allowTypes = '', path = '', type = 'file') => {
    const [location, setLocation] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const { data: resultUploads, postData: upload } = usePost(false)
    const { data: resultdelete, loading: loadingDeleting, postData: deleteItem } = usePost(false)
    const [isMulti, setIsMulti] = useState(false)
    const [multiFileLength, setMultiFileLength] = useState(0)

    const handleDelete = (keyFile) => {
        const _data = {
            keyFile: keyFile,
        }
        deleteItem(`${process.env.REACT_APP_UPLOADS_API_BASE_URL}/delete`, _data)
    }

    const isAllowedType = (file) => {
        if (!Array.isArray(allowTypes)) return true
        return allowTypes.find((allowed) => {
            if (allowed === file.type) return true
            if (file.name.toLowerCase().endsWith('.webp') && (allowed === 'image/webp' || allowed === '.webp')) return true
            if (allowed === 'image/*' && file.type.startsWith('image/')) return true
            return false
        })
    }

    const handleUpload = async (event) => {
        setLoading(true)
        const file = event.target.files[0] || null
        if (file) {
            if (isAllowedType(file)) {
                const fileName = file.name
                try {
                    const _formData = new FormData()
                    _formData.append('myfile', file, fileName)
                    upload(`${process.env.REACT_APP_UPLOADS_API_BASE_URL}/${path}`, _formData)
                } catch (error) {
                    setLoading(false)
                    setError(error)
                }
            } else {
                setLoading(false)
                setError(new Error('Unsupported file type'))
            }
        } else {
            setLoading(false)
        }
    }

    const handleMultiUploads = async (event) => {
        setIsMulti(true)
        setLoading(true)
        const files = Object.values(event.target.files || {})
        setMultiFileLength(files.length)
        files.forEach((file, index) => {
            if (file) {
                if (isAllowedType(file)) {
                    const fileName = file.name
                    try {
                        const _formData = new FormData()
                        _formData.append('myfile', file, fileName)
                        upload(`${process.env.REACT_APP_UPLOADS_API_BASE_URL}/${path}`, _formData)
                        setTimeout(() => {
                            return index
                        }, 5000)
                    } catch (error) {
                        setLoading(false)
                        setError(error)
                    }
                } else {
                    setLoading(false)
                    setError(new Error('Unsupported file type'))
                }
            }
        })
    }

    useEffect(() => {
        if (resultUploads && !isMulti) {
            setLoading(false)
            setLocation(resultUploads.data.location)
        }
        if (resultUploads && isMulti) {
            setLocation(resultUploads.data.location)
            setMultiFileLength((state) => state - 1)
            if (multiFileLength === 1) {
                setLoading(false)
            }
        }
    }, [resultUploads])

    return {
        location,
        loading,
        error,
        handleUpload,
        handleMultiUploads,
        resultdelete,
        loadingDeleting,
        handleDelete,
    }
}

export default useUploadFile
